import { authTokenStorage } from './authTokenStorage'

export interface UserCredentials {
    userId: number
    mail: string
    groupIds: number[]
    profileIds: number[]
    companyId: number
    userWorkFlowId: number | null
    daysForPasswordExpiration: number
    fullName: string
    defaultLanguage: string
    isBankGroup: boolean
    isInternalGroup: boolean
    isAdmin: boolean
    codCargo: number
    cargo: string
    canCreateNewMessage: boolean
}

class UserStorage {
    keyStorage = 'userWorkflowStorage'

    public save(
        userId: number,
        mail: string,
        groupIds: number[],
        profileIds: number[],
        userWorkFlowId: number | null,
        daysForPasswordExpiration: number,
        fullName: string,
        defaultLanguage: string,
        isBankGroup: boolean,
        isInternalGroup: boolean,
        authToken: string,
        isAdmin: boolean,
        codCargo: number,
        cargo: string,
        canCreateNewMessage: boolean
    ) {
        const userCredentials: UserCredentials = {
            userId: userId,
            mail: mail,
            groupIds: groupIds,
            profileIds: profileIds,
            companyId: 1,
            userWorkFlowId: userWorkFlowId,
            daysForPasswordExpiration: daysForPasswordExpiration,
            fullName: fullName,
            defaultLanguage: defaultLanguage,
            isBankGroup: isBankGroup,
            isInternalGroup: isInternalGroup,
            isAdmin: isAdmin,
            codCargo: codCargo,
            cargo: cargo,
            canCreateNewMessage: canCreateNewMessage
        }

        localStorage.setItem(this.keyStorage, JSON.stringify(userCredentials))

        authTokenStorage.save(authToken)
    }

    public get(): UserCredentials {
        return JSON.parse(localStorage.getItem(this.keyStorage) as string) as UserCredentials
    }

    public removeFromStorage() {
        localStorage.removeItem(this.keyStorage)

        authTokenStorage.removeFromStorage()
    }

    public getUserId() {
        return this.get()?.userId
    }

    public getMailUser() {
        return this.get().mail
    }

    public getGroupIds() {
        return this.get().groupIds
    }

    public getProfileIds() {
        return this.get()?.profileIds
    }

    public getCompanyId() {
        return this.get().companyId
    }

    public getUserWorkflowId() {
        return this.get().userWorkFlowId
    }

    public getDaysForPasswordExpiration() {
        return this.get().daysForPasswordExpiration
    }

    public getFullName() {
        return this.get().fullName
    }

    public getDefaultLanguage() {
        return this.get().defaultLanguage
    }

    public hasToken() {
        return authTokenStorage.get() !== null
    }

    public isAdmin(): boolean {
        return this.get().isAdmin
    }

    public getUsuarioCargo(): string {
        return this.get().cargo
    }

    public getUsuarioCodCargo(): number {
        return this.get().codCargo
    }

    public canCreateNewMessage(): boolean {
        return this.get().canCreateNewMessage
    }
}

export const userStorage = new UserStorage()
